<template>
  <b-modal
    id="add-occasion-modal"
    ref="modal"
    header-class="headerModal"
    centered
    :title="$t('AddOccasion')"
    hide-footer
    class="custom-modal"
    @close="onCancel"
  >
    <b-form>
      <b-form-group
        id="input-group-1"
        :label="$t('OccasionName')"
        label-for="occasion-input"
      >
        <b-form-input
          id="occasion-input"
          v-model="occasionName"
          type="text"
          :placeholder="$t('EnterOccasionName')"
          required
        />
      </b-form-group>

      <div class="buttonsEverywhere">
        <button
          type="button"
          class="buttonSubmit"
          style="margin-top: 10px;"
          @click="onSubmit"
        >
          {{ $t('Submit') }}
        </button>
        <b-button
          type="button"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; margin-top: 10px; background: white; color: black; border-color: white; font-weight: 400;"
          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      occasionName: '',
    }
  },
  methods: {
    ...mapActions(['addCampaignLovOccasion']),
    
    openModal() {
      this.$refs.modal.show()
    },
    
    closeModal() {
      this.$refs.modal.hide()
      this.occasionName = ''
    },

    async onSubmit() {
      if (!this.occasionName) return
      
      await this.addCampaignLovOccasion({
        name: this.occasionName,
        successCallback: () => {
          this.$emit('refreshOccasions')
          this.closeModal()
        },
      })
    },

    onCancel() {
      this.closeModal()
    }
  },
}
</script>

<style lang="scss" scoped>
</style>